/**
 * Dlaždica Mury v knižnici portálu. Obal je banner od používateľa
 * (`public/art/mura/cover.webp`, z `scripts/mura-art.mjs`), ten istý ako
 * pozadie titulky hry; názov je cez neho, lebo banner nápis nemá.
 */

import { GameCard } from '../../portal/GameCard.js';
import type { PortalTileProps } from '../registry.js';

export function MuraTile({ navigate }: PortalTileProps) {
  return (
    <GameCard
      title="Mura: Hlas z podzemia"
      status="wip"
      badge="Demo"
      titleStyle={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 700, letterSpacing: '0.12em' }}
      players="1 hráč"
      duration="~10 min (demo)"
      tags={['Plošinovka', 'Skrývanie', 'Hádanky', 'Bez textu', 'Klávesnica / gamepad']}
      description="Prebudíš sa v podzemnom kláštore medzi ľuďmi bez vlastnej vôle. Mnísi s bronzovými maskami strážia každý krok. Skrývaj sa v tieni, splyň s radom kopáčov a nájdi cestu von. Prvá kapitola."
      onPlay={() => navigate('#/mura')}
      cover={
        <span className="libCover" style={{ background: '#050609' }}>
          <img className="libCover__img" src="/art/mura/cover.webp" alt="Mura" draggable={false} style={{ objectPosition: '50% 35%' }} />
          <span
            style={{
              position: 'absolute',
              right: 18,
              top: '50%',
              transform: 'translateY(-50%)',
              fontFamily: "'Cinzel', Georgia, serif",
              fontWeight: 700,
              fontSize: '2.4rem',
              letterSpacing: '0.3em',
              color: '#d8e8ef',
              textShadow: '0 0 18px rgba(127, 216, 255, 0.45), 0 2px 6px rgba(0, 0, 0, 0.9)',
            }}
          >
            MURA
          </span>
        </span>
      }
    />
  );
}
